import React, { lazy } from 'react';
import { Star, Check } from 'lucide-react';
import { ImageCarousel } from './ImageCarousel';
const IMAGES = ['https://cdn.magicpatterns.com/uploads/8U6jwPDsPXzUm5bwg9GMyE/ChatGPT_Image_24_ene_2026,_10_43_52_p.m..png', 'https://cdn.magicpatterns.com/uploads/vw9mEeJ7KRTDDvmCYnhDyb/ChatGPT_Image_24_ene_2026,_12_41_35_a.m..png', 'https://cdn.magicpatterns.com/uploads/oAVMLSeX3x7Yt9QGT67eZR/ChatGPT_Image_24_ene_2026,_10_45_55_p.m..png', 'https://cdn.magicpatterns.com/uploads/xaqLvvaU2RydaLARxW973P/ChatGPT_Image_24_ene_2026,_10_49_39_p.m..png'];
export function HeroSection() {
  return <section className="relative overflow-hidden bg-[#FAF5EF] pt-8 pb-16 lg:pt-16 lg:pb-24" data-id="element-95">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-96">
        {/* Emotional Opening */}
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-97">
          <span className="inline-block py-1 px-3 rounded-full bg-rose-100 text-rose-700 font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-98">
            🔥 No estás rota. Estás en alerta.
          </span>
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-99">
            Si tu mente no se detiene, si tu cuerpo nunca termina de relajarse,
            si funcionas por fuera pero vives en tensión por dentro…
            <br className="hidden md:block" data-id="element-100" />
            No es porque falles. No es debilidad. No es "tu cabeza".
          </p>
          <p className="mt-4 text-xl md:text-2xl font-bold text-[#C06B6B]" data-id="element-101">
            👉 Es tu cuerpo intentando protegerte. Y eso, hoy, puede cambiar.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16 items-start" data-id="element-102">
          {/* Left Column: Carousel */}
          <div className="relative" data-id="element-103">
            <span className="absolute top-4 left-4 z-10 rounded-full bg-[#C06B6B] px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-white shadow-sm" data-id="element-104">
              Popular
            </span>
            <ImageCarousel images={IMAGES} data-id="element-105" />
          </div>

          {/* Right Column: Product Info */}
          <div className="flex flex-col justify-center" data-id="element-106">
            {/* Reviews */}
            <div className="flex items-center gap-2 mb-4" data-id="element-107">
              <div className="flex text-[#C4973B]" data-id="element-108">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-4 w-4 fill-current" data-id="element-109" />)}
              </div>
              <span className="text-sm font-medium text-gray-600" data-id="element-110">
                4.9/5 • 2,400+ mujeres ya lo usan
              </span>
            </div>

            {/* Title */}
            <h1 className="text-4xl font-serif font-bold text-gray-900 sm:text-5xl mb-2" data-id="element-111">
              🌿 Calma tu mente en solo 5 minutos
            </h1>
            <p className="text-xl text-[#C06B6B] font-medium mb-6" data-id="element-112">
              con el Protocolo Calma-5™
            </p>

            {/* Price */}
            <div className="flex items-center gap-4 mb-8 p-4 bg-white/50 rounded-xl border border-[#C06B6B]/20 w-fit" data-id="element-113">
              <span className="text-3xl font-bold text-gray-900" data-id="element-114">$10.99</span>
              <span className="text-xl text-gray-400 line-through" data-id="element-115">$47</span>
              <span className="rounded-md bg-rose-100 px-2 py-1 text-sm font-bold text-rose-700" data-id="element-116">
                Ahorras $36
              </span>
            </div>

            {/* Description */}
            <div className="prose prose-stone mb-6 text-gray-600" data-id="element-117">
              <p data-id="element-118">
                Un audio guiado corto y suave, diseñado para ayudar a tu cuerpo
                a salir del estado de alerta en tiempo real, incluso cuando la
                mente no se calla.
              </p>
            </div>

            {/* Checklist */}
            <ul className="space-y-2 mb-8" data-id="element-119">
              {['Acceso inmediato', 'Uso diario o cuando lo necesites', 'No necesitas experiencia previa', "Ideal si la ansiedad aparece 'de la nada'"].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700" data-id="element-120">
                  <Check className="h-5 w-5 text-[#C4973B]" data-id="element-121" />
                  <span data-id="element-122">{item}</span>
                </li>)}
            </ul>

            <p className="text-[#C06B6B] font-bold mb-4 text-sm uppercase tracking-wide" data-id="element-123">
              Hoy con 40% de descuento + 2 bonos gratis
            </p>

            {/* CTA */}
            <a href="https://pay.hotmart.com/Y104339646N?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto rounded-full bg-[#C4973B] px-8 py-4 text-lg font-bold text-white shadow-md hover:bg-[#B08632] hover:shadow-lg transition-all transform hover:-translate-y-0.5 mb-6 text-center inline-block" data-id="element-124">
              👉 Escuchar mi primera sesión ahora
            </a>

            {/* Bonus Preview */}
            <div className="border-t border-gray-200 pt-6" data-id="element-125">
              <p className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2" data-id="element-126">
                <span className="text-lg" data-id="element-127">🎁</span> + 2 Bonus GRATIS incluidos:
              </p>
              <div className="flex gap-4" data-id="element-128">
                <div className="flex items-center gap-2" data-id="element-129">
                  <img src={IMAGES[2]} alt="Bonus: Respiraciones que Calman" className="h-12 w-10 object-cover rounded shadow-sm" loading="lazy" data-id="element-130" />
                  <span className="text-xs text-gray-600 max-w-[100px] leading-tight" data-id="element-131">
                    Respiraciones que Calman
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-132">
                  <img src={IMAGES[3]} alt="Bonus: Rutinas Nocturnas" className="h-12 w-10 object-cover rounded shadow-sm" loading="lazy" data-id="element-133" />
                  <span className="text-xs text-gray-600 max-w-[100px] leading-tight" data-id="element-134">
                    Rutinas Nocturnas
                  </span>
                </div>
              </div>
            </div>

            {/* Guarantee Badge */}
            <div className="mt-6 flex items-center gap-3 bg-rose-50 border border-rose-200 rounded-xl px-4 py-3 w-fit" data-id="element-135">
              <div className="flex items-center gap-2" data-id="element-136">
                <div className="h-2.5 w-2.5 rounded-full bg-rose-500 animate-pulse" data-id="element-137"></div>
                <span className="text-sm font-semibold text-rose-800" data-id="element-138">
                  Acceso inmediato digital
                </span>
              </div>
              <div className="h-4 w-px bg-rose-300" data-id="element-139"></div>
              <div className="flex items-center gap-1.5" data-id="element-140">
                <span className="text-sm font-semibold text-rose-800" data-id="element-141">
                  🛡️ Garantía de 7 días
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}